<template>
  <section v-if="pageLoader" class="games-page games-page-loader">
    <button class="button-loader"></button>
  </section>
  <section v-else class="games-page">
    <h1 class="heading">
      <div class="container-mobile">{{ $t("games.games") }}</div>
    </h1>
    <div class="info-block container-mobile">
      <ul class="games-list">
        <li
          v-for="game in games"
          class="games-item"
          :key="game.id"
          :class="'games-item-' + game.id"
        >
          <div class="games-avatar"></div>
          <div class="games-title">{{ game.title }}</div>
          <router-link
            :to="{ name: 'game', params: { id: game.id } }"
            class="games-button button"
            >{{ $t("games.play") }}</router-link
          >
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "Games",
  props: {
    i18n: Object,
  },
  data() {
    return {
      pageLoader: false,
      games: [
        {
          id: 1,
          title: this.$t("games.yesNo"),
        },
        // {
        //     id: 2,
        //     title: 'Русская рулетка'
        // },
        {
          id: 3,
          title: this.$t("games.twistingTurning"),
        },
        {
          id: 4,
          title: this.$t("games.theUndressingFool"),
        },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/pages/_games";
</style>
